import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { Router } from '@angular/router';
import { Workplace } from '@qaroni-app/workplace/types/workplace';
import { qaroniAnimations } from '@qaroni-shared/animations/qaroni-animations';

@Component({
  selector: 'qaroni-card-workplace',
  templateUrl: './card-workplace.component.html',
  styleUrls: ['./card-workplace.component.scss'],
  animations: [qaroniAnimations.enterFadeIn()],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CardWorkplaceComponent {
  readonly workplace = input<Workplace | null>(null);
  readonly first = input<boolean>(false);

  private router = inject(Router);

  public goToWorkplaceDetails(): void {
    if (this.workplace()?.companyId && this.workplace()?.workplaceId) {
      this.router.navigate([
        `/companies/${this.workplace()?.companyId}/workplaces/${this.workplace()?.workplaceId}/details`,
      ]);
    }
  }

  public goToWorkplaceUpdate(): void {
    if (this.workplace()?.companyId && this.workplace()?.workplaceId) {
      this.router.navigate([
        `/companies/${this.workplace()?.companyId}/workplaces/${this.workplace()?.workplaceId}/update`,
      ]);
    }
  }
}
